import { render, staticRenderFns } from "./ModalCadastroQhRecesso.vue?vue&type=template&id=18b8ec8e"
import script from "./ModalCadastroQhRecesso.vue?vue&type=script&lang=js"
export * from "./ModalCadastroQhRecesso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports